import { ACCESS_TOKEN } from 'src/constants/access-token';
export const getAuthorization = () => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
        return `Bearer ${token}`;
    }
    return null;
};
